export function cleanHtmlString(input: string): string {
  if (!input) return '';

  // Step 1: Strip HTML tags
  const withoutTags = input.replace(/<\/?[^>]+(>|$)/g, '');

  // Step 2: Decode HTML entities using DOMParser
  if (typeof window !== 'undefined') {
    const parser = new DOMParser();
    const decoded = parser.parseFromString(withoutTags, 'text/html').documentElement.textContent;
    return decoded || '';
  }

  // Fallback for non-browser environments (e.g., Node.js)
  return withoutTags
    .replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(dec))
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>');
}